import { MetaMaskProvider } from 'metamask-react'

import { AppAuthProvider } from './AppAuthContext'
import { AppErrorProvider } from './AppErrorContext'
import { ArcanaAuthProvider } from './ArcanaAuthContext'
import { DeviceTypeProvider } from './DeviceContext'
import { AppSuccessMessageProvider } from './SuccessMessageContext'
import { composeContexts } from './helpers/composeContexts'

export const ComposedProviders = composeContexts([
  AppAuthProvider,
  AppErrorProvider,
  AppSuccessMessageProvider,
  MetaMaskProvider,
  ArcanaAuthProvider,
  DeviceTypeProvider,
])
